import { UiServiceV2 } from './ui.service-v2.service';
import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { API_SERVICE_CONFIG } from '@fullyops/legacy/data/api/ApiServiceConfig';
import { IApiServiceConfig } from '@fullyops/legacy/data/api/IApiServiceConfig';
import { TravelAssigneeResponse } from '@fullyops/legacy/data/api/types/Travel';

type QueryParameters = {
  createdBy?: string;
  includeDeleted?: boolean;
  installationTicketId?: string;
  order?: 'ASC' | 'DESC';
  orderBy?:
    | 'CREATED_AT'
    | 'UPDATED_AT'
    | 'UUID'
    | 'STARTING_HOUR'
    | 'ENDING_HOUR'
    | 'STAY'
    | 'DISTANCE';
  page?: number;
  size?: number;
  supportTicketId?: string;
  updatedBy?: string;
};

@Injectable({
  providedIn: 'root',
})
export class TravelAssigneeControllerV2 extends UiServiceV2 {
  constructor(
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
    private http: HttpClient,
  ) {
    super();
  }

  private readonly url = this.config.url + 'travels/assignees';

  assignUserToTravel(props: { assigneeId: string; travelId: string }) {
    return this.http.post<TravelAssigneeResponse>(this.url, props);
  }

  unAssignUserToTravel(props: { assigneeId: string; travelId: string }) {
    return this.http.delete(
      `${this.url}/${props.travelId}/${props.assigneeId}`,
    );
  }
}
